import { Component, OnInit, Input } from '@angular/core';
import { AppleLoginService } from '../_services/apple-login.service';
import { ActivatedRoute } from '@angular/router';
import { FirebaseService } from 'app/services/firebase.service';

@Component({
  selector: 'apple-login',
  templateUrl: './apple-login.component.html',
  styleUrls: ['./apple-login.component.scss', '../account.scss'],
})
export class AppleLoginComponent implements OnInit {
  @Input() redirectUrl;
  @Input() isSignUp;

  constructor(
    private appleLoginService: AppleLoginService,
    public activatedRoute: ActivatedRoute,
    private firebaseService: FirebaseService,
    ) {
  }

  ngOnInit() {
    this.appleLoginService.init();
  }

  signIn() {
    this.appleLoginService.signIn(this.redirectUrl , this.isSignUp);
    this.firebaseService.logEvent('login', {
      method: 'apple',
    });
  }

}
